// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import Zone from "@insite/client-framework/Components/Zone";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

export interface OnePageCheckoutConfirmationSuccessMessageStyles {
    infosBox?: InfosBoxProps;
    container?: GridContainerProps;
    textItem?: GridItemProps;
    buttonsItem?: GridItemProps;
    subtitle?: TypographyProps;
    text?: TypographyProps;
}

export const onePageCheckoutConfirmationSuccessMessageStyles: OnePageCheckoutConfirmationSuccessMessageStyles = {
    infosBox: { type: "success" },
    container: {
        gap: 32,
    },
    textItem: {
        width: [12, 12, 7, 7, 7],
        css: css`
            flex-direction: column;
        `,
    },
    buttonsItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            align-items: flex-end;
        `,
    },
    subtitle: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            margin-bottom: ${pxToRem(5)};
        `,
    },
    text: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-bottom: ${pxToRem(5)};
        `,
    },
};

const styles = onePageCheckoutConfirmationSuccessMessageStyles;

const OnePageCheckoutConfirmationSuccessMessage = ({ id }: WidgetProps) => {
    return (
        <InfosBox {...styles.infosBox}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.textItem}>
                    <Typography {...styles.subtitle}>{translate("Thank you for your order!")}</Typography>
                    <Typography {...styles.text}>{translate("A confirmation email has been sent to")}</Typography>
                    <Typography {...styles.text}>
                        {translate(
                            "A temporary order number has been generated and will be updated once FLS confirms the order. You can preview this change in your Order History.",
                        )}
                    </Typography>
                </GridItem>
                <GridItem {...styles.buttonsItem}>
                    <Zone contentId={id} zoneName="ActionButtons" />
                </GridItem>
            </GridContainer>
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutConfirmationSuccessMessage,
    definition: {
        displayName: "Success Message",
        group: "One Page Checkout Confirmation",
        allowedContexts: ["OnePageCheckoutConfirmationPage"],
    },
};

export default widgetModule;
